import { intl } from '@fullstory/intl';
import React from 'react';
import { RouteProps } from 'react-router-dom';
import { identifyComponent } from '../../util';
import { BreadcrumbItemProps } from './BreadcrumbItem';
import css from './Breadcrumbs.module.scss';

export interface BreadcrumbsProps {
  testId?: string;
  children:
    | React.ReactElement<BreadcrumbItemProps | RouteProps>[]
    | React.ReactElement<BreadcrumbItemProps | RouteProps>;
}

const ariaLabel = intl.formatMessage({
  defaultMessage: 'Breadcrumb',
  id: '6wswEC',
  description:
    'A breadcrumb is a graphical control element used as a navigational aid in user interfaces and on web pages. It allows users to keep track and maintain awareness of their locations within the website.',
});

/**
 * Breadcrumbs is used to provide navigational actions and context to a user.
 *
 * You must add a Breadcrumbs component and the appropriate <Breadcrumbs.Item /> children on every
 * page for which you wish to render the component. The last child of <Breadcrumbs /> will be
 * assumed to be the 'active' page and will render with a darker text color.
 */
export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ testId = 'breadcrumbs', children }) => (
  <nav data-component="Breadcrumbs" aria-label={ariaLabel} {...identifyComponent('breadcrumbs')}>
    <ol className={css.breadcrumbList}>{children}</ol>
  </nav>
);
